import { Track } from '@bariendo/lib/constants';
import { isCiIntroCallNote, isPnConsultationAnswers, parseCiIntroCallAnswers } from '@bariendo/lib/patient-access-note';
import { PreferredProcedureDate, readPreferredProcedureDate } from '@bariendo/lib/pn-consultation-note';
import { getReferenceString } from '@medplum/core';
import { Communication, Patient } from '@medplum/fhirtypes';
import type { PacQueueHydration } from '../hooks/usePacQueueHydration';
import { buildFinancingRows, FinancingLeadRow } from './financingRows';
import { isReadyToSchedule } from './readyToScheduleScope';

export interface ToScheduleRow extends FinancingLeadRow {
  preferredDate?: PreferredProcedureDate;
  /** Shown under the Insurance pill; the stage bot stored it with the status. */
  insurer?: string;
}

/** From the newest PN consultation note that recorded one. */
function preferredDateFrom(notes: Communication[] | undefined): PreferredProcedureDate | undefined {
  for (const note of notes ?? []) {
    if (!isCiIntroCallNote(note)) continue;
    const answers = parseCiIntroCallAnswers(note);
    const preferred = isPnConsultationAnswers(answers) ? readPreferredProcedureDate(answers) : undefined;
    if (preferred) return preferred;
  }
  return undefined;
}

/** The Financing rows (BAR-3096), with the preferred date and the insurer. */
export function buildToScheduleRows(
  patients: Patient[],
  hydration: PacQueueHydration,
  now: Date,
  showPaymentStatus: boolean
): ToScheduleRow[] {
  return buildFinancingRows(patients, hydration, now, {}, showPaymentStatus, isReadyToSchedule).map((row) => ({
    ...row,
    preferredDate: preferredDateFrom(hydration.callNotesByPatient.get(getReferenceString(row.patient) ?? '')),
    insurer: row.track === Track.INSURANCE ? row.paymentStatus?.payor : undefined,
  }));
}
